import {
  getCurrentResources,
  getFileUrlPrefix,
  getPlatformWebConfig,
  httpGetPswKey,
  httpLogin,
  platformLogin,
  saasLogin,
  saasProfile,
  saasQrCodeLogin,
  getChildrenDicts,
  getUCenterInfo,
  X_TRANSFER_KEY,
} from '@/services'
import { dfs, triggerSetFileUrlPrefix } from 'shj-utils'
import {
  getToken,
  getTreeList,
  getUser,
  getUserInfo,
  onLogout,
  saveToken,
  treeToOneArr,
} from '@/common/utils'
import config from '@/layouts/config'
import md5 from 'md5'
import { cloneDeep, get, set, isNil } from 'lodash-es'
import menuPlatform from '@/config/menu-platform'
import { baseConfig } from '@/config/base-config'
import { useNavigate } from 'react-router-dom'
import KJUR from 'jsrsasign'
import { enableRequest } from '@/api'
import { theme } from 'antd'
// import ShjGreenTheme from '@/themes/shj-green/theme-token.ts'
// import LrRedTheme from '@/themes/lr-red/theme-token.ts'
import global from '@/utils/global.ts'
import useGlobalStore from '@/store'
import { controlPanelAuth, controlPanelPreAuth, tenantAuth } from '@/services/user.ts'
// import { TOKEN_KEY } from 'shj-utils/dist/esm/request'
import { setThemeRoot } from '@/utils/common.ts'

const PUB_KEY_BODY = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwoKwaYIJolhYovY7E/bTt72ZAie8ei0g4BwpekYTAAIdTKBukRxLTJc8yOJdrKhA/3mXRjONgw3teYVyf8rtZMTHOa2B2j1mHM/2bXFeHKVvoxXegh9L2DpQDKquJ4UnEuW/LgPNjqwkwy63pR/JSlSdOA0VzKpzh7tS3qL7F6r9rDNgWNXylRcxWBWjNDINAXW5IBF0MH4uVeGGNQfMAfVAfh+WhcP6rdSj308vgXvAwvGzx/grGhrboRCTV66K0iNL0CUqQD/Mbd7fKpcWvHQ8GaQ7LgUEVA5OhiWXfQ5jPTsadzJ5+b4V6JaYliZSj8IhjNFy3YLXZcujY875dQIDAQAB`
export const PUB_KEY = `-----BEGIN PUBLIC KEY-----${PUB_KEY_BODY}-----END PUBLIC KEY-----`

function hexStringToBase64(hexStr) {
  const bytes: any[] = []
  for (let i = 0; i < hexStr.length; i += 2) {
    bytes.push(parseInt(hexStr.substring(i, i + 2), 16))
  }
  return btoa(String.fromCharCode.apply(null, bytes))
}

export function bodyEncrypt(data) {
  const datString = JSON.stringify(data)
  // const loginEncrypted = encrypt.encrypt(datString) // rsa 加密
  const keyData = KJUR.KEYUTIL.getKey(PUB_KEY)
  const loginEncrypted = KJUR.crypto.Cipher.encrypt(datString, keyData, 'RSA') // rsa 加密
  // console.log('bodyEncrypt', data)
  // console.log('loginEncrypted', loginEncrypted)
  return hexStringToBase64(loginEncrypted) // 转base64
  // return encode(loginEncrypted) // 转base64
}

export const getLoginSuccessRoutePath = userInfo => {
  //开发环境
  // if (process.env.NODE_ENV === 'development') return '/main'
  // 非生活家的其他租户
  if (userInfo?.tenantId?.indexOf?.('shj') == -1) return '/main'
  if (process.env.APP_TYPE === 'platform') {
    return ''
  }
  // return '/portal/index'
  return '/main'
}
export default function useUser() {
  const { menuList } = config
  const navigate = useNavigate()
  const getAppType = () => process.env.APP_TYPE

  const isPlatform = () => getAppType() === 'platform'
  const {
    token: { colorPrimary, colorBgBase },
  } = theme.useToken()

  const setGlobalUser = useGlobalStore((state: any) => state.setUser)
  const setUserExtend = useGlobalStore((state: any) => state.setUserExtend)
  const setGlobalTheme = useGlobalStore((state: any) => state.setTheme)
  const setHasAuthMenu = useGlobalStore((state: any) => state.setHasAuthMenu)
  const setGlobalMenu = useGlobalStore((state: any) => state.setMenu)
  const setMenuSource = useGlobalStore((state: any) => state.setMenuSource)
  const setMenuLoading = useGlobalStore((state: any) => state.setMenuLoading)
  const fetchTheme = useGlobalStore((state: any) => state.fetchTheme)

  const setFaviconAndTitle = data => {
    const { icon, title } = data
    // 设置浏览器标签 favicon
    let linkEl: any = document.querySelector("link[rel*='icon']")
    const hasLinkEl = !!linkEl
    if (!hasLinkEl) linkEl = document.createElement('link')
    linkEl.type = 'image/x-icon'
    linkEl.rel = 'shortcut icon'
    linkEl.href = icon
    if (!hasLinkEl) {
      document.querySelector('head')?.appendChild?.(linkEl)
    }

    // 设置浏览器title
    if (title) {
      document.title = title
      sessionStorage.setItem('TENANT_TITLE', title)
    }
  }

  // //设置主题
  // const setTheme = data => {
  //   // console.log(data)
  //   let currentTheme = ShjGreenTheme
  //   if (data?.theme == 'shj-green') {
  //     currentTheme = ShjGreenTheme
  //   }
  //   if (data?.theme == 'lr-red') {
  //     currentTheme = LrRedTheme
  //   }
  //   setGlobalTheme(currentTheme)
  //   localStorage.setItem('ANTD_CONFIG_PROVIDER', JSON.stringify(currentTheme))
  //   setThemeRoot(currentTheme)
  // }

  // const setThemeRoot = theme => {
  //   const { token, themContent } = theme
  //   for (let item in themContent) {
  //     document.documentElement.style.setProperty(item, themContent[item])
  //   }
  // }

  const getWebConfig = async () => {
    // if (isPlatform()) return Promise.resolve()
    return getPlatformWebConfig().then(data => {
      // const { logo, loginLogo, loginImageUrls, cropId, agentId } = data
      setFaviconAndTitle(data)
      // setTheme(data)
      sessionStorage.setItem('CONFIG_LOGO', data.logo)
      return data
    })
  }

  const getLogo = () => {
    return sessionStorage.getItem('CONFIG_LOGO')
    // const storeLogo = sessionStorage.getItem('CONFIG_LOGO')
    // if (storeLogo) {
    //   return Promise.resolve(storeLogo)
    // } else {
    //   return getConfig().then(data => data.logo)
    // }
  }

  const SVIUserInfo = async () => {
    const userRes: any = await getUserInfo()
    const fileUrl = await getFileUrlPrefix()

    triggerSetFileUrlPrefix(JSON.stringify(fileUrl))
    return userRes.data
  }

  const postSViLogin = async (username, password) => {
    try {
      const resKey: any = await httpGetPswKey({ params: { username } })

      const salt = resKey?.data?.data || ''
      const resData: any = await httpLogin({
        params: { username, password: md5(`${password}${salt}`) },
      })

      const authData = get(resData, 'data', {})
      if (authData.status) {
        saveToken(authData?.data, authData?.expireDate)
        return SVIUserInfo().then(userInfo => Promise.resolve(userInfo))
      }
      return Promise.reject()
    } catch (err) {
      // console.log('err', err)
      return Promise.reject(err)
    }
  }
  const saveUserToken = resData => {
    const { accessToken, refreshToken, extend } = resData
    saveToken(accessToken.token)
    localStorage.setItem('expireAt', accessToken.expireAt)
    localStorage.setItem('refreshToken', refreshToken.token)
    localStorage.setItem('refreshExpireAt', refreshToken.expireAt)
    if (extend) {
      localStorage.setItem('userExtend', JSON.stringify(extend))
      setUserExtend(extend)
    }
  }

  const saveLoginData = async resData => {
    // console.log('saveLoginData', resData)
    try {
      saveUserToken(resData)
      enableRequest()
      const [userRes]: any = await Promise.allSettled([getProfile(), getMenu()])
      const userInfo = userRes.value
      // const userInfo: any = await getProfile()
      // localStorage.setItem('user', 'undefined')

      if (userInfo) {
        sessionStorage.setItem('PROFILE_FETCHED', '1')
        fetchTheme(userInfo)
      }
      return Promise.resolve(userInfo)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  // const postSaaSLogin = async (workerNumber, password) => {
  //   await getPlatformWebConfig()
  //   try {
  //     // const resData: any = await saasLogin({ workerNumber, password })
  //     const resData: any = await saasLogin({ encryptBody: bodyEncrypt({ workerNumber, password }) })
  //     return saveLoginData(resData)
  //   } catch (err) {
  //     // console.log(err)
  //     return Promise.reject(err)
  //   }
  // }

  const postTalentAuth = async (workerNumber, password) => {
    // await getPlatformWebConfig()
    try {
      // const resData: any = await saasLogin({ workerNumber, password })
      const resData: any = await saasLogin({ encryptBody: bodyEncrypt({ workerNumber, password }) })
      return saveLoginData(resData)
    } catch (err) {
      // console.log(err)
      return Promise.reject(err)
    }
  }
  const postTenantAuth = async (userName, password, type = 'ACCOUNT') => {
    // await getPlatformWebConfig()
    try {
      // const resData: any = await saasLogin({ workerNumber, password })
      // const resData: any = await tenantAuth(
      //   //   {
      //   //   encryptBody:
      //   //     bodyEncrypt({ workerNumber, password })
      //   // }
      //   { userName, password, type }
      const resData: any = await controlPanelPreAuth(
        //   {
        //   encryptBody:
        //     bodyEncrypt({ workerNumber, password })
        // }
        { userName, password, type }
      )
      return resData
    } catch (err) {
      // console.log(err)
      return Promise.reject(err)
    }
  }

  const postTenantLogin = async (authCode, tenantId) => {
    // await getPlatformWebConfig()
    try {
      // const resData: any = await saasLogin({ workerNumber, password })
      const resData: any = await tenantLogin({ authCode }, { [X_TRANSFER_KEY]: tenantId })
      localStorage.setItem(X_TRANSFER_KEY, tenantId)
      return saveLoginData(resData)
    } catch (err) {
      console.log(err)
      return Promise.reject(err)
    }
  }

  /** 只调用登录接口 **/
  const postLogin = async (authCode, userId, tenantId) => {
    return controlPanelAuth(userId, { authCode }, { [X_TRANSFER_KEY]: tenantId })
  }

  /** 调用登录并查询、保存用户信息 **/
  const postAuthLogin = async (authCode, userId, tenantId) => {
    // await getPlatformWebConfig()
    try {
      // const resData: any = await saasLogin({ workerNumber, password })
      const resData: any = await postLogin(authCode, userId, tenantId)
      localStorage.setItem(X_TRANSFER_KEY, tenantId)
      return saveLoginData(resData)
    } catch (err) {
      console.log(err)
      return Promise.reject(err)
    }
  }

  const postPlatformLogin = async (account, password) => {
    try {
      const resData: any = await platformLogin(
        // { account, password }
        { loginName: account, password }
      )
      // console.log('postPlatformLogin', resData)
      localStorage.setItem('user', JSON.stringify({ workNumber: account }))
      localStorage.setItem('userExtend', JSON.stringify({}))

      saveUserToken(resData)
      // localStorage.setItem(tokenKey, JSON.stringify(resData.authToken))
      // saveToken(resData.authToken)
      return { path: '/platform/lessee' }
    } catch (err) {
      // console.log(err)
    }
  }

  const loginPreAuth = async (username, password, type) => postTenantAuth(username, password, type)

  const login = (workerNumber, password) => {
    const loginFn =
      {
        platform: postPlatformLogin,
        svi: postSViLogin,
      }[process.env.APP_TYPE || ''] || postTenantLogin

    return loginFn(workerNumber, password)
  }

  const QRLogin = (code, agentId) => {
    return saasQrCodeLogin(code, agentId).then(loginRes => {
      localStorage.setItem(X_TRANSFER_KEY, loginRes?.info?.tenantId)
      return saveLoginData(loginRes)
    })
  }

  const adaptUserData = result => {
    const user = getUser()

    result = Object.assign({}, user, result)

    // 兼容原来 SVI 用户数据
    const adapter = [
      {
        key: 'currentDepartmentPosition.department.code',
        value: result.currentDepartmentPosition?.deptCode,
      },
      {
        key: 'currentDepartmentPosition.department.name',
        value: result.currentDepartmentPosition?.deptName,
      },
      {
        key: 'currentDepartmentPosition.department.company.code',
        value: result.currentDepartmentPosition?.companyCode,
      },
      {
        key: 'currentDepartmentPosition.department.company.id',
        value: result.currentDepartmentPosition?.companyId,
      },
      {
        key: 'currentDepartmentPosition.department.company.name',
        value: result.currentDepartmentPosition?.companyName,
      },
      {
        key: 'currentDepartmentPosition.position.code',
        value: result.currentDepartmentPosition?.positionCode,
      },
      {
        key: 'currentDepartmentPosition.position.name',
        value: result.currentDepartmentPosition?.positionName,
      },
      {
        key: 'currentDepartmentPosition.position.id',
        value: result.currentDepartmentPosition?.positionId,
      },
    ]

    adapter.map(d => set(result, d.key, d.value))

    const storeExtend = localStorage.getItem('userExtend')

    if (storeExtend && storeExtend !== 'undefined') {
      try {
        const userExtend = JSON.parse(storeExtend)
        set(result, 'currentRoles[0].dataLevel', userExtend.dataScope)
      } catch (e) {
        // console.log(e)
      }
    }
    return result
  }
  const getProfile = async () => {
    // console.log('getProfile:', getToken())
    if (!getToken()) {
      onLogout?.()
      navigate('/login', { replace: true })
      return
    }
    getFileUrlPrefix().then(fileUrl => {
      if (typeof fileUrl === 'string') {
        triggerSetFileUrlPrefix(JSON.stringify(fileUrl))
      }
    })

    if (process.env.APP_TYPE === 'platform') {
      return Promise.resolve(getUser())
    }

    const PROFILE_FETCHED = sessionStorage.getItem('PROFILE_FETCHED')
    try {
      if (!PROFILE_FETCHED) {
        // const result: any = await getUserInfo()
        let result: any = await saasProfile()
        const newProfileRes: any = await getUCenterInfo(result.workNumber)
        const { userName, tenantAvatar: photo } = newProfileRes
        result = adaptUserData(result)

        setGlobalUser({ ...result, name: userName, photo })

        if (result) {
          localStorage.setItem(
            'user',
            JSON.stringify(
              Object.assign(result, { workNumber: result.workNumber, name: userName, photo })
            )
            // 'undefined'
          )

          // 判断公司，保证成交王的主题，出错不影响主流程
          try {
            const resList: any = await getChildrenDicts(['companyTheme'])
            const objId = resList?.[0]?.dataValue
            const companyId = result?.companyId
            if (objId === companyId) {
              localStorage.setItem('isLr', 'true')
            } else {
              localStorage.setItem('isLr', 'false')
            }
          } catch (err) {
            console.log(err)
          }
        }
        return Promise.resolve(newProfileRes)
      } else {
        sessionStorage.removeItem('PROFILE_FETCHED')
      }
    } catch (err) {
      return Promise.reject(err)
    }
  }

  const setUserButtonList = button => {
    const user = getUser()
    if (user && Array.isArray(button)) {
      user.buttonList = button.map(key => ({
        key,
        hasAccess: true,
      }))
      localStorage.setItem('user', JSON.stringify(user))
    }
  }

  const getParamAuth = () => {
    // GetGeneralParamConfField()
    //   .then(paramAuth => {
    //     console.log('paramAuth', paramAuth)
    //     localStorage.setItem('paramAuth', JSON.stringify(paramAuth))
    //   })
    //   .catch(() => {
    //     localStorage.setItem('paramAuth', JSON.stringify([{}]))
    //   })
  }

  const getMenu = async () => {
    if (process.env.APP_TYPE === 'platform') {
      // setGlobalMenu(menuPlatform)
      setGlobalMenu(menuPlatform)
      return Promise.resolve(menuPlatform)
    }
    // setGlobalMenu([...baseConfig])
    // console.time('getMenu')
    let userAuth: any
    let paramAuth: any
    let menu = global.menu
    if (!menu?.length) {
      try {
        setMenuLoading(true)
        userAuth = await getCurrentResources()
        // paramAuth = await GetGeneralParamConfField()

        // getParamAuth()
        const { button, fields } = userAuth || {}
        menu = (userAuth?.menu || []).filter(d => !isNil(d.children))
        setMenuSource(cloneDeep(menu))
        // console.log('userAuth', userAuth)
        // console.log('paramAuth', paramAuth)
        // console.log('button', button, userAuth)
        const roleCodesAuthority =
          button?.reduce?.((result, item) => {
            // result[item] = 1
            result[item.key] = 1
            return result
          }, {}) || {}

        const fieldAuth = fields.reduce((result, item) => ({ ...result, [item.key]: 1 }), {})
        // console.log('userAuth', menu)
        // const applications = menu?.filter(item => item.sysVisibleFlag)

        /** 合并按钮与菜单权限 **/
        const menuAuth = {}
        menu.map((item: any) => {
          if (!menuAuth[item.key]) {
            menuAuth[item.key] = {}
          }
          dfs(item.children, d => {
            menuAuth[item.key][d.key] = 1
          })
        })

        setUserButtonList(button)
        // console.log('menu', menu)
        // setHasAuthMenu(!!menu.find((d: any) => d.key === 'CAAS'))
        setHasAuthMenu(!!menu.find((d: any) => d.key === 'enterpriseBackground'))
        localStorage.setItem('menuAuth', JSON.stringify(menuAuth))
        localStorage.setItem('buttonAuth', JSON.stringify(roleCodesAuthority))
        localStorage.setItem('fieldAuth', JSON.stringify(fieldAuth))
      } catch (err) {
        // console.log(err)
        return Promise.reject(err)
      }
    }

    // dfs(menu, d => {
    //   if (d.children) {
    //     d.children = d.children.filter(item => item.type === 'menu' && item.sysVisibleFlag)
    //   }
    // })
    // console.log(menu)

    localStorage.setItem('menuList', JSON.stringify(menu))
    // dfs(menu, d => {
    //   d.icon = null
    // })
    // console.log('setGlobalMenu', menu)

    global.menu = menu

    // gougm  手动添加订单服务菜单
    // let newArr: any = [
    //   {
    //     icon: 'saas-obs/202406/66602609e4b0779fb39f5817.svg',
    //     key: 'order',
    //     name: '订单服务',
    //     nid: 'A10701',
    //     path: '/order',
    //     pid: '22',
    //     sortNumber: '22',
    //     sysVisibleFlag: true,
    //     type: 'menu',
    //   },
    // ]
    // menu = menu.concat(newArr)
    setGlobalMenu([...menu, ...baseConfig])
    setMenuLoading(false)
    const treeArrayList = treeToOneArr(cloneDeep(menu))
    const list = treeArrayList?.filter(item => item.type === 'menu' && item.sysVisibleFlag)

    // const menuList = getTreeList(list, '0', [])

    // setGlobalMenu(menuList)

    console.timeEnd('getMenu')
    // return config.menuList
    return list
  }

  const updateUserDeptPos = deptPos => {
    const storeUser = getUser()
    if (storeUser) {
      storeUser.currentDepartmentPosition = deptPos
      localStorage.setItem('user', JSON.stringify(storeUser))
    }
  }
  return {
    getWebConfig,
    getLogo,
    loginPreAuth,
    login,
    getMenu,
    getProfile,
    getAppType,
    isPlatform,
    saveUserToken,
    setThemeRoot,
    bodyEncrypt,
    saveLoginData,
    QRLogin,
    getLoginSuccessRoutePath,
    updateUserDeptPos,
    postTenantLogin,
    postLogin,
    postAuthLogin,
  }
}
